document.addEventListener("DOMContentLoaded", function () {
    const slidingServiceSwipers = document.querySelectorAll('.services-swiper');

    if(slidingServiceSwipers.length > 0) {
        slidingServiceSwipers.forEach((serviceSwiper) => {
            const swiperId = serviceSwiper.dataset.unique;

            const servicesSwiper = new Swiper(`.services-swiper[data-unique=${swiperId}]`, {
                // Optional parameters
                loop: true,
                slidesPerView: 1.5,
                spaceBetween: 8,
                centeredSlides: true,
                autoplay: false,
                allowTouchMove: true, // Enable touch/swipe gestures
                speed: 800,
                navigation: {
                    nextEl: `.services-slider .swiper-controls[data-controls=${swiperId}] .next`,
                    prevEl: `.services-slider .swiper-controls[data-controls=${swiperId}] .prev`,
                },
            });
        });
    }
});